/* eslint-disable import/no-extraneous-dependencies */
import { Component, OnInit, inject, input } from "@angular/core";
import { ICorrDocumentDownload, ICorrListItem } from "@api";
import CorrespondenceRole from "@models/CorrespondenceRole";
import LocalContractUserService from "@services/local-contractUser.service";

@Component({
  selector: "leftPanel",
  templateUrl: "./leftPanel.component.html",
  standalone: false
})
export default class LeftPanelComponent implements OnInit {
  localContractUserService = inject(LocalContractUserService);

  readonly entity = input<ICorrListItem>(undefined);

  readonly docs = input<ICorrDocumentDownload[]>(undefined);

  readonly defaultTab = input("details");

  isDBAdmin = true;
  
  ngOnInit(): void {
    const role = this.localContractUserService.currentUserContractRole;
    this.isDBAdmin = role === CorrespondenceRole.DBAdmin;
  }
}
